module.exports = {
  bank: "bank",
  gym: "gym",
  home: "home",
  school: "school",
  work: "work",
  other: "other",
};
